import { useEffect, useState } from 'react';

const useModalFocus = ({ active, ref }) => {
  const [previousFocusEl, setPreviousFocusEl] = useState(null);

  useEffect(() => {
    const currentRef = ref.current;

    // Set it and forget it
    if (!previousFocusEl) {
      setPreviousFocusEl(document.activeElement);
    }

    // Timeout ensures our state updates before changing focus
    if (active) {
      setTimeout(() => {
        currentRef.focus();
      });
    }

    return () => previousFocusEl?.focus();
  }, [ref, previousFocusEl, active]);
};

export default useModalFocus;
